import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {APP_INITIALIZER, NgModule} from "@angular/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from "@angular/common/http";
import {RouterModule} from "@angular/router";
import {AppRoutingModule} from "./app.routing";
import {ComponentsModule} from "./components/components.module";
import {AppComponent} from "./app.component";
import {AdminLayoutComponent} from "./layouts/admin-layout/admin-layout.component";
import {StoreDevtoolsModule} from "@ngrx/store-devtools";
import {StoreModule} from "@ngrx/store";
import {metaReducers, reducers} from "./reducers";
import {environment} from "environments/environment";
import {EffectsModule} from "@ngrx/effects";
import {ToastrModule} from "ngx-toastr";
import {AuthEffects} from "./modules/auth/_state/auth.effects";
import {AuthInterceptor} from "./modules/auth/_services/auth.interceptor.service";
import {SharedModule} from "./shared/shared.module";
import {SharedEffects} from "./shared/_state/shared.effect";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {HashLocationStrategy, LocationStrategy} from "@angular/common";
import {DashboardEffects} from "./modules/dashboard/_state/dashboard.effects";
import {SafePipe} from "./shared/pipes/safe.pipe";
// import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import {GoogleMapsModule} from "@angular/google-maps";
import {MixpanelInterceptor} from "./misc/mixpanel/mixpanel.interceptor";
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
@NgModule({
    imports: [
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        ComponentsModule,
        RouterModule,
        SharedModule,
        // GooglePlaceModule,
        // NgMultiSelectDropDownModule.forRoot(),
         BsDatepickerModule.forRoot(),
        AppRoutingModule,
        ToastrModule.forRoot({preventDuplicates: true}),
        GoogleMapsModule,
        EffectsModule.forRoot([AuthEffects, SharedEffects, DashboardEffects]),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        StoreModule.forRoot(reducers, {
            metaReducers,
            runtimeChecks: {
                strictStateImmutability: true,
                strictActionImmutability: true,
            },
        }),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: environment.production,
            connectInZone: true,
        }),
        HttpClientModule,
    ],
    declarations: [AppComponent, AdminLayoutComponent, SafePipe],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MixpanelInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializerFactory,
            deps: [TranslateService],
            multi: true,
        },
        {provide: LocationStrategy, useClass: HashLocationStrategy},
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http);
}

export function appInitializerFactory(translate: TranslateService) {
    return async () => {
        translate.setDefaultLang("en");
        await translate.use("fr").toPromise();
        await translate.use("es").toPromise();
        await translate.use("pt").toPromise();
        const returnValue = await translate.use("en").toPromise();
        return returnValue;
    };
}
